import storage from '@/util/storage';
import {JSEncrypt} from 'jsencrypt';
import {isEmpty, randomString} from '@/util/appUtils';
export const USER_KEY = 'LoginUser';
let loginInfo = null;
/**
 * 保存用户信息到缓存
 * @param info
 */
export const login = (info) => {
  loginInfo = info;
  storage.save(USER_KEY, info);
};
/**
 * 请用缓存中的用户信息
 */
export const logout = () => {
  loginInfo = null;
  storage.remove(USER_KEY);
};
/**
 * 从缓存中获取用户信息
 * @return {String|Object|Array|null}
 */
export const getLoginInfo = () => {
  if (loginInfo !== null) {
    return loginInfo;
  }
  loginInfo = storage.get(USER_KEY);
  return loginInfo;
}

/**
 * 获取token
 * @return {*|string}
 */
export const getToken = () => {
  const loginInfo = getLoginInfo();
  if (!loginInfo) {
    return '';
  }
  return loginInfo.token;
};
/**
 * 注入token
 * @param headers
 */
export const injectToken = ({headers}) => {
  const token = getToken();
  if (isEmpty(token)) {
    return;
  }
  headers.token = token;
};
/**
 * 获取publicKey
 * @returns {*|string}
 */
export const getPublicKey = () => {
  const loginInfo = getLoginInfo();
  if (!loginInfo) {
    return '';
  }
  return loginInfo.publicKey;
};
/**
 * 获取sessionKey
 * @returns {string|false|string}
 */
export const getSessionKey = () => {
  const token = getToken();
  const publicKey = getPublicKey();
  if (isEmpty(token) || isEmpty(publicKey)) {
    return '';
  }
  const timestamp = Date.now();
  const crypt = new JSEncrypt();
  crypt.setKey(publicKey);
  return crypt.encrypt([token, timestamp, randomString({length: 6})].join(','));
};
/**
 * 注入sessionKey
 * @param headers
 */
export const injectSessionKey = ({headers}) => {
  const sessionKey = getSessionKey();
  if (isEmpty(sessionKey)) {
    return;
  }
  headers.sessionKey = sessionKey;
};

export const getSysUser = ()=> {
  const loginInfo = getLoginInfo();
  if (!loginInfo) {
    return null;
  }
  return loginInfo.sysUser;
};
/**
 * 获取所属社区列表
 * @returns {*|*[]}
 */
export const getCommunityList = () => {
  const loginInfo = getLoginInfo();
  if (!loginInfo) {
    return [];
  }
  if (!Array.isArray(loginInfo.communityList)) {
    return [];
  }
  return loginInfo.communityList;
};

export const getWeekPassword = () => {
  return storage.get('weekPassword');
};

export const setWeekPassword = (bool) => {
  storage.save('weekPassword', bool);
}

/**
 * 判断用户是否有权限，参考菜单管理和角色管理
 * @param url 页面的地址
 * @param code 权限编码
 * @return {boolean}
 */
export const hasRight = ({url, code}) => {
  const loginInfo = getLoginInfo();
  if (!loginInfo) {
    return false;
  }
  const rightList = loginInfo.rightList;
  if (!Array.isArray(rightList)) {
    return false;
  }
  if (!url) {
    url = window.location.pathname;
  }
  for (const item of rightList) {
    if (item.menuUrl !== url) {
      continue;
    }
    const rightCodes = item.rightCodes;
    if (!Array.isArray(rightCodes)) {
      continue;
    }
    for (const rightCode of rightCodes) {
      if (rightCode === code) {
        return true;
      }
    }
  }
  return false;
};